<template>
  <div class="bg-light">
    <div class="fixed-top pb-1 border-bottom bg-white">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center" style="height: 36px">
          <router-link class="text-dark text-decoration-none small pt-1" to="/pedidos"><i class="fa fa-chevron-left mr-2"></i><b>Monitor de Preparo</b></router-link>
          <div>
            <button class="btn text-dark btn-topbar" title="Sincronizar" @click="buscarPedidos()">
              <i class="fa fa-sync-alt mr-1" style="width: 20px"></i>
            </button>
            <button class="btn text-dark btn-topbar" title="Configs" @click="modalConfigs = true">
              <i class="fa fa-cog mr-1" style="width: 20px"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid container-kanban">
      <div class="row no-gutters d-lg-none my-3">
        <div class="col-6 pr-1"><button :class="menu === 1 ? 'btn-secondary' : 'btn-outline-dark'" class="btn btn-block" @click="menu = 1">Aguardando <span v-if="aguardando.length" class="badge badge-light">{{ aguardando.length }}</span></button></div>
        <div class="col-6"><button :class="menu === 2 ? 'btn-info' : 'btn-outline-dark'" class="btn btn-block" @click="menu = 2">Preparando <span v-if="preparando.length" class="badge badge-light">{{ preparando.length }}</span></button></div>
      </div>
      <div class="row no-gutters">
        <div class="col-lg-8 pr-lg-1">
          <div :class="{'aberto': menu === 1}" class="kanban-coluna">
            <div class="kanban-col-header bg-secondary">
              <div class="text-uppercase">Fila de Preparo<span v-if="aguardando.length">: {{ aguardando.length }}</span></div>
              <a class="text-white" href="javascript:" title="Inciar todos" @click.prevent="alterarEmMassa('2')">
                <i class="fa fa-check-double"></i>
              </a>
            </div>
            <div class="kanban-col-body">
              <loading v-if="load" style="padding-top: 42px"/>
              <div v-show="!load" class="row no-gutters">
                <div v-for="(p, i) in aguardando" :key="i" class="col-md-4">
                  <kds-item :pedido="p" @editar="acaoPedido" @imprimir="selImpressao" @open="openModalPedido"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 pr-lg-1">
          <div :class="{'aberto': menu === 2}" class="kanban-coluna">
            <div class="kanban-col-header bg-info">
              <div>Preparando<span v-if="preparando.length">: {{ preparando.length }}</span></div>
              <a class="text-white" href="javascript:" title="Concluir todos" @click.prevent="alterarEmMassa('3')">
                <i class="fa fa-check-double"></i>
              </a>
            </div>
            <div class="kanban-col-body">
              <span id="topPreparando"></span>
              <loading v-if="load" style="padding-top: 42px"/>
              <div v-show="!load">
                <div class="row no-gutters">
                  <div v-for="(p, i) in preparando" :key="i" class="col-md-12">
                    <kds-item :pedido="p" @editar="acaoPedido" @imprimir="selImpressao" @open="openModalPedido"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'show': modalPedido}" class="modal-pdv modal-kanban">
      <div v-show="modalPedido" class="modal-pdv-content p-0">
        <div class="pd">
          <div class="pd-header border-bottom shadow-sm">
            <button class="btn btn-outline-dark" style="width: 42px; font-size: 18px" title="Fechar" @click="fecharModalPedido()">
              <i class="fa fa-chevron-left"></i>
            </button>
            <div v-if="!loadDetalhes" class="d-md-none">
              <a class="btn btn-primary" href="javascript:" @click="imprimir(selecionado)"><i class="fa fa-print"></i></a>
            </div>
          </div>
          <div class="pd-content rounded">
            <loading v-if="loadDetalhes" style="padding-top: 48px"/>
            <div v-else-if="selecionado">
              <cupom-delivery :selecionado="selecionado" preview="true"/>
            </div>
          </div>
          <div v-if="selecionado" class="pd-bottom border-top bg-white">
            <div class="d-flex justify-content-between">
              <div class="btn-cancelar mr-2">
                <button class="btn btn-dark btn-block" @click="fecharModalPedido()">Voltar</button>
              </div>
              <div class="btn-imprimir mr-2">
                <button :class="{'visibility':!selecionado.status}" class="btn btn-outline-dark btn-block" @click="prepararImpressao()">
                  Imprimir
                </button>
              </div>
              <div v-if="selecionado.status === '1'" class="btn-aceitar ml-auto">
                <button class="btn btn-success btn-block" @click="acaoPedido(selecionado.id_pedido,'2')">Iniciar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :opened="modalImpressao">
      <div v-if="selecionado && selecionado.cozinhas" class="container-fluid">
        <h6 class="font-weight-bold text-center">Qual local você quer imprimir?</h6>
        <div class="my-3">
          <label class="mb-0 d-block mb-3">
            <input v-model="cozinhas" :value="impressora.device" class="mr-1" type="checkbox">
            Caixa (Default)
          </label>
        </div>
        <div v-for="c in selecionado.cozinhas" class="my-3">
          <label class="mb-0 d-block mb-3">
            <input v-model="cozinhas" :value="c.device" class="mr-1" type="checkbox">
            {{ c.nome_cozinha }}
          </label>
        </div>
        <div class="border-top pt-3 text-center d-flex justify-content-between">
          <button class="btn btn-light border p-3 " @click="modalImpressao = false"><i class="fa fa-angle-left"></i> Voltar</button>
          <button class="btn btn-success p-3" @click="imprimir(selecionado, cozinhas)">
            Imprimir
          </button>
        </div>
      </div>
    </modal>

    <modal :opened="modalConfigs">
      <div class="container-fluid">
        <h6 class="text-center font-weight-bold">Configurações</h6>
        <hr>
        <div class="form-group">
          <label class="mb-0">Iniciar pedido</label>
          <select v-model="config.auto_print" class="form-control">
            <option :value="false">Não imprimir</option>
            <option :value="true">Imprimir</option>
          </select>
        </div>
        <div class="form-group">
          <label class="mb-0">
            <input :checked="alterDevice" type="checkbox" @change="alterDevice = !alterDevice"> Alterar impressora
          </label>
          <input v-model="config.device" :disabled="!alterDevice" class="form-control" placeholder="Nome da impressora" type="text">
        </div>
        <div class="border-top d-flex justify-content-between pt-3 mt-4">
          <button class="btn btn-dark px-4" @click="fecharModalConfigs()">Fechar</button>
          <button class="btn btn-success px-4" @click="salvarConfigs()">Salvar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import TopBar from '../../components/commons/TopBar.vue'
import Modal from '../../components/gestor/ModalGestor'
import Loading from '../../components/gestor/loading';
import CupomDelivery from "../../components/gestor/CupomDelivery";
import KdsItem from "../../components/gestor/KdsItem";

export default {
  name: 'KdsGestor',
  components: {
    KdsItem,
    CupomDelivery,
    Loading,
    Modal,
    TopBar
  },

  data() {
    return {
      token: localStorage.getItem('key'),
      empresaToken: localStorage.getItem('token'),
      load: false,
      loadDetalhes: false,

      selecionado: null,
      pesquisa: { status: '2', key: null },
      pedidos: [],

      lecardTimeOut: null,
      reconnectTimer: null,
      socketTimeout: null,
      intervalAgr: null,

      modalPedido: false,
      modalConfigs: false,
      modalImpressao: false,
      cozinhas: [],
      multiple: false,

      modalOutros: false,
      menu: 1,

      alterDevice: false,
      config: { auto_print: false, device: '' }
    }
  },

  methods: {
    buscarPedidos(id_pedido) {
      this.load = !id_pedido;
      const params = { ...this.pesquisa, id_pedido: id_pedido || null }

      this.$http.get('v2/pedidos/fila', { params })
        .then(response => {
          this.load = false;
          const pedidos = response.data || [];
          this.pedidos = pedidos.map(p => this.normalizarPedido(p));

        }, res => {
          this.load = false;
          const data = res.data || {};

          if (res.status === 401) {
            this.logout(true);

          } else if (!navigator.onLine) {
            this.$swal("Não conseguimos sincronizar os pedidos. Por favor verifique se seu computador tem uma conexão estável.");

          } else {
            this.$swal(data.msg || "Não foi possível sincronizar os pedidos.");
          }
        });
    },

    buscarPedidoId(id_pedido, callback) {
      this.$http.get(`delivery/pedidos/${this.token}/${id_pedido}`)
        .then(response => {
          const data = response.data || {};

          if (data.id_pedido) {
            callback(data);

          } else {
            callback(null);
            this.$swal(`Pedido ${dados.id_pedido} não encontrado!`)
          }

        }, res => {
          console.log(res);
          callback(null);

          if (res.status === 401) {
            this.logout(true);
          }
        });
    },

    openModalPedido(id_pedido) {
      this.modalPedido = true;
      this.loadDetalhes = true;

      this.buscarPedidoId(id_pedido, (data) => {
        this.loadDetalhes = false;

        if (data) {
          this.selecionado = data;
        }
      });
    },

    fecharModalPedido() {
      this.modalPedido = false;
      this.selecionado = null;
    },

    acaoPedido(id_pedido, status) {
      const pedido = this.pedidos.find(p => p.id_pedido === id_pedido);

      if (!pedido || pedido.status === status) return;

      let dados = {
        status,
        id_pedido,
        id_empresa: pedido.id_empresa,
        empresa: pedido.token
      };

      pedido.status = status;
      const imprimir = (status === '2' && this.config.auto_print);

      if (imprimir) {
        this.$store.state.load = 'Alterando status';
      }

      this.$http.post('delivery/kds/' + this.token, dados)
        .then(res => {
          this.$store.state.load = false;
          const data = res.data;

          if (data.success) {
            if (imprimir) {
              this.selImpressao(id_pedido, true);

            } else if (this.modalPedido && this.selecionado) {
              this.selecionado.status = status;
            }

            this.$socket.emit('delivery_kds', { token: pedido.token, content: { id_pedido, status } });

          } else {
            this.$swal(data.msg || "Por favor, tente novamente");
            this.buscarPedidos();
          }

        }, res => {
          this.$store.state.load = false;
          const error = (res.data || {}).msg || 'Não foi possível alterar o status deste pedido. Por favor verifique sua conexão com a internet.';
          const errorStatus = (res.data || {}).status || status;

          this.$swal(error).then(() => {
            if (errorStatus == 2) {
              this.buscarPedidos();
            }
          });
        });
    },

    alterarEmMassa(status) {
      const oldStatus = (parseInt(status) - 1);
      const pedidosFila = this.pedidos.filter(p => parseInt(p.status) === oldStatus);

      if (!pedidosFila.length) {
        this.$swal('Não há pedidos nesta fila');
        return;
      }

      this.$swal({
        text: "Deseja limpar todos os pedidos desta fila?",
        buttons: ['Não', 'Sim']
      }).then((res) => {
        if (res) {
          this.load = true;
          const pedidos = pedidosFila.map(p => p.id_pedido);

          this.$http.post('delivery/kds/' + this.token, { status, pedidos })
            .then(res => {
              this.load = false;

              if (res?.data.success) {
                this.$socket.emit('delivery_kds', { token: this.empresaToken, content: { pedidos, status } });
                this.updatePedidos(pedidos, status);

              } else {
                this.buscarPedidos();
              }

            }, res => {
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });
        }
      });
    },

    updatePedidos(pedidos, status) {
      const arrayPedidos = this.pedidos.filter(p => pedidos.includes(p.id_pedido));

      arrayPedidos.forEach(p => {
        p.status = status.toString();
      });
    },

    selImpressao(id_pedido, auto) {
      this.$store.state.load = 'Buscando dados';
      this.buscarPedidoId(id_pedido, (data) => {
        this.$store.state.load = false;

        if (data) {
          this.selecionado = data;

          this.$nextTick(() => {
            if (auto) {
              this.imprimir(this.selecionado);

            } else {
              this.prepararImpressao();
            }
          })
        }
      });
    },

    prepararImpressao() {
      if (!this.selecionado.id_pedido) {
        return;
      }

      if (!this.impressora.mobilePrint && this.selecionado.cozinhas && this.selecionado.cozinhas.length) {
        this.cozinhas = [this.impressora.device];
        this.modalImpressao = true;

      } else {
        this.imprimir(this.selecionado);
      }
    },

    imprimir(pedido, cozinhas) {
      let html = document.getElementById('containerPedido');

      if (!html) return false;

      html = html.cloneNode(true);
      html.querySelectorAll('.d-print-none').forEach(el => el.remove());
      let content = html.innerHTML.replace(/\sdata-v-[a-z0-9\-]+="[^"]*"/gi, '').replace(/<!--[\s\S]*?-->/g, '').trim();
      let dataPrint = [];
      let detail = {
        content,
        copies: 1,
        status: 1,
        id_pedido: pedido.id_pedido,
        nome_documento: `Pedido ${pedido.id_contador}`,
        device: this.config.device || this.impressora.device || null,
        impressora: {
          device: this.impressora.device || null,
          largura: this.impressora.largura,
          zoom: this.impressora.zoom
        }
      };

      if (!this.impressora.mobilePrint && (cozinhas || pedido.cozinhas)) {
        this.modalImpressao = false;

        if (!cozinhas && this.impressora.printCashier) {
          detail.copies = 1;
          dataPrint.push(detail);
        }

        const devices = cozinhas || pedido.cozinhas.map(c => { return c.device });

        for (let i = 0; i < devices.length; i++) {
          dataPrint.push({
            content,
            copies: 1,
            status: 1,
            id_pedido: pedido.id_pedido,
            nome_documento: `Pedido ${pedido.id_contador}`,
            device: devices[i] || null,
            impressora: {
              device: devices[i] || null,
              largura: this.impressora.largura,
              zoom: this.impressora.zoom
            }
          })
        }

      } else {
        dataPrint.push(detail);
      }

      this.$helpers.imprimir(this, pedido.token, dataPrint, this.impressora.mobilePrint);
      return true;
    },

    loopPedidos() {
      if (this.lecardTimeOut) {
        clearTimeout(this.lecardTimeOut);
        this.lecardTimeOut = null;
      }

      this.lecardTimeOut = setTimeout(() => {
        if (!this.$socket.connected) {
          window.location.reload();

        } else {
          this.buscarPedidos();
        }

        this.loopPedidos();
      }, (1000 * 60 * 5));
    },

    normalizarPedido(pedido) {
      const nome_cliente = (pedido.tipo_cliente === '2' ? pedido.obs_pedido : pedido.nome_cliente) || '';
      const minutos = this.$dayjs().diff(this.$dayjs(pedido.data_pedido), 'minute');

      return {
        ...pedido,
        nome_cliente,
        tempo_pedido: Math.max(minutos, 0),
        status: pedido.status_cozinha,
        _nome_cliente: nome_cliente.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase(),
      };
    },

    fecharModalConfigs() {
      this.alterDevice = false;
      this.modalConfigs = false;
    },

    salvarConfigs() {
      localStorage.setItem('kdsConfigs', JSON.stringify(this.config));
      this.fecharModalConfigs();
    }
  },

  mounted() {
    if (!this.token) {
      this.logout(true);
      return;
    }

    this.pesquisa.key = this.token;
    this.multiple = this.empresas.length > 1;
    this.config = this.$helpers.parseJSONObject(localStorage.getItem('kdsConfigs')) || this.config;

    this.buscarPedidos();
    this.loopPedidos();

    this.intervalAgr = setInterval(() => {
      this.pedidos.forEach(pedido => {
        pedido.tempo_pedido++;
      });
    }, 60000);
  },

  beforeDestroy() {
    if (this.lecardTimeOut) {
      clearTimeout(this.lecardTimeOut);
      this.lecardTimeOut = null;
    }

    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }

    if (this.intervalAgr) {
      clearInterval(this.intervalAgr);
      this.intervalAgr = null;
    }
  },

  computed: {
    empresas() {
      return this.$store.state.empresas
    },

    impressora() {
      return this.$store.state.impressora
    },

    aguardando() {
      return this.pedidos.filter(p => p.status === '1').sort((a, b) => {
        return parseInt(a.id_pedido) - parseInt(b.id_pedido);
      });
    },

    preparando() {
      return this.pedidos.filter(p => p.status === '2').sort((a, b) => {
        return parseInt(a.id_pedido) - parseInt(b.id_pedido);
      });
    }
  },

  sockets: {
    connect() {
      if (!this.reconnectTimer) {
        this.reconnectTimer = setTimeout(() => {
          this.buscarPedidos();
          this.reconnectTimer = null;
        }, 1000 * 5);
      }
    },

    disconnect() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },

    delivery_kds(data) {
      if (!data || !data.status) {
        return;
      }

      const status = parseInt(data.status);

      if (status && data.pedidos) {
        this.updatePedidos(data.pedidos, status);
        return;
      }

      if (data.id_pedido) {
        const id_pedido = parseInt(data.id_pedido);
        const pedido = this.pedidos.find(p => parseInt(p.id_pedido) === id_pedido);

        if (pedido) {
          pedido.status = status.toString();

        } else if ([1,2].includes(status)) {
          this.buscarPedidos(id_pedido);
        }
      }
    }
  }
}
</script>

<style scoped>
.btn-topbar {
  padding: 0 6px 0 6px;
}

.kanban-coluna {
  background-color: #FFFFFF;
  border: 1px solid #e9ecef;
  margin-bottom: 6px;
  border-radius: 8px;
  overflow: hidden;
}

.kanban-col-header {
  padding: 7px 12px;
  font-size: 0.8em;
  color: #FFFFFF;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
}

.kanban-col-body {
  height: calc(100vh - 100px);
  overflow: auto;
  padding: 0 4px;
}

.modal-kanban .modal-pdv-content {
  margin-top: 72px;
  height: calc(100vh - 110px);
  border: 12px;
}

.container-kanban {
  margin-top: 52px;
  padding-right: 12px;
  padding-left: 12px;
}

.pd {
  height: 100%;
}

.pd-header {
  padding: 6px 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pd-content {
  padding: 18px 12px 12px;
  height: calc(100% - 118px);
  overflow: auto;
}

.pd-bottom {
  padding: 12px 12px 0;
}

@media (min-width: 992px) {
  .modal-kanban .modal-pdv-content.is-modal {
    margin-top: 48px;
    max-width: 420px;
  }
}

@media (max-width: 991px) {
  .kanban-coluna {
    display: none;
    margin-bottom: 12px;
  }

  .kanban-coluna.aberto {
    display: block;
  }

  .kanban-col-body {
    height: auto;
    min-height: 520px;
  }
}

@media (max-width: 767px) {
  .kanban-coluna {
    display: none;
    margin-bottom: 82px;
  }
}
</style>
